<template>
   <nav-bar />
  <router-view/>
  <app-fotter />
</template>

<script>
 
import AppFotter from './components/AppFotter.vue';
import NavBar from './components/NavBar.vue';

export default {
   methods:{
      async initializeAppData() {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          await Promise.all([
            this.$store.dispatch('getCurrentUser'),
            this.$store.dispatch('getNotifications')
          ]);
          console.log("all data was update");
        } catch (error) {
          console.error("data was not updated", error);
        }
      }
    },


    mounted() {
    this.initializeAppData();
    this.$store.dispatch('getCurrentUser');
  },
 

   },
 
  components: {
    NavBar, AppFotter
  },
 created() {
  if(localStorage.getItem("token")) {
    this.$router.push("/dashboard");
  }
 }
  
};
</script>





<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 
}
body {
  font-family: 'Inter', sans-serif !important;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
